(function () {
    'use strict';
    angular
        .module('ib-pmt-donation-module')
        .controller('IbPmtDonationController', IbPmtDonationController);
    IbPmtDonationController.$inject = ['$scope', 'PmtUtilsService', 'localStorageService', 'DatalayerEcommerceUtilsService'];
    function IbPmtDonationController ($scope, PmtUtilsService, localStorageService, DatalayerEcommerceUtilsService) {
        const vm = this;
        vm.checkDonation = checkDonation;
        vm.updateFormCheck = updateFormCheck;
        vm.viewItemListAdded = false;

        activate();

        function activate () {
            updateModel();
        }

        function checkDonation (option, donationInfo, newsletter, donationOptionIndex, isSelectItem) {
            if(!isSelectItem) { vm.doDonation = !vm.doDonation; }
            donationInfo = PmtUtilsService.disabledOptionDonation(donationInfo);
            vm.donationOptionIndex = donationOptionIndex;
            option.selected = true;
            updateFormCheck(donationOptionIndex);
            if(vm.doDonation && !vm.viewItemListAdded) {
                DatalayerEcommerceUtilsService.setDonationsViewItemList(donationInfo);
                vm.viewItemListAdded = true;
            } else if(vm.doDonation && vm.viewItemListAdded && isSelectItem) {
                DatalayerEcommerceUtilsService.setDonationsSelectItem(donationInfo, option);
            }
            $scope.$emit('checkDonation', vm.doDonation, option, donationInfo, newsletter, vm.donation && vm.donation.form ? vm.donation.form : null);
        }

        function updateFormCheck (donationOptionIndex) {
            let i = 0;
            vm.donation = localStorageService.get('donation') ? localStorageService.get('donation') : {};
            vm.donation.form = vm.donation.form || {};
            vm.donation.form.acceptDonation = vm.acceptDonation;
            vm.donation.form.acceptDonationData = vm.acceptDonationData;
            vm.donation.form.option = vm.donation.form.option ? vm.donation.form.option : [];
            if (vm.donation.form.option.length > 0) {
                for (i = 0; i < vm.donation.form.option.length; i++) {
                    vm.donation.form.option[i] = i === donationOptionIndex;
                }
            } else {
                for (i = 0; i < vm.donationInfo.quantity.length; i++) {
                    vm.donation.form.option[i] = i === donationOptionIndex;
                }
            }

            localStorageService.set('donation', vm.donation);
        }

        function updateModel () {
            let i = 0;
            vm.donation = localStorageService.get('donation') ? localStorageService.get('donation') : {};
            vm.doDonation = vm.donation.option ? vm.donation.option.selected : false;
            vm.acceptDonation = vm.donation.form ? vm.donation.form.acceptDonation : null;
            vm.acceptDonationData = vm.donation.form ? vm.donation.form.acceptDonationData : null;
            vm.donation.form = vm.donation.form ? vm.donation.form : {};
            if (!vm.donation.form.option && vm.donationInfo) {
                vm.donation.form.option = [];
                for (i = 0; i < vm.donationInfo.quantity.length; i++) {
                    vm.donation.form.option[i] = i === 0;
                }
            }
        }
    }
})();